export default __webpack_public_path__ + "static/media/help_call.8d5d43d9.png";